<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data() {
    return {
      gradient: null,
      gradient2: null,
      gradient3: null
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient3 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(255, 0,0, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(255, 0, 0, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 0, 0, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

    this.gradient3.addColorStop(0, "rgba(255, 0, 253, 0.22)");
    this.gradient3.addColorStop(0.5, "rgba(255, 0, 253, 0.22)");
    this.gradient3.addColorStop(1, "rgba(255, 0, 253, 0.22)");

    this.renderChart(
      {
        labels: [
          "Uttara",
          "Boshundhara",
          "Banani",
          "Gulshan",
          "Dhanmondi",
          "Mohammadpur",
          "Malibag",
          "Mirpur",
          "Mohakhali"
        ],
        datasets: [
          {
            label: "Roti",
            borderColor: "#FC2525",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "white",
            backgroundColor: this.gradient,
            data: [40, 39, 10, 40, 39, 80, 40, 50, 90]
          },
          {
            label: "Singara",
            borderColor: "#05CBE1",
            pointBackgroundColor: "white",
            pointBorderColor: "white",
            borderWidth: 1,
            backgroundColor: this.gradient2,
            data: [60, 55, 32, 10, 2, 12, 53, 40, 33]
          },
          {
            label: "Porota",
            borderColor: "#d940ff",
            pointBackgroundColor: "white",
            borderWidth: 1,
            pointBorderColor: "white",
            backgroundColor: this.gradient3,
            data: [30, 20, 50, 10, 5, 100, 60, 60, 3]
          },
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>
